import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
const NewBooks = lazy(() => import('@!/Store/NewBooks/containers/NewBooks'))

const NewBooksApp = (props) => {
  return (
    <AppProvider>
      <Suspense fallback={null}>
        <NewBooks tabName={props.tab_name} />
      </Suspense>
    </AppProvider>
  )
}

export default NewBooksApp
